/**
 * Шкала свежести — ОДНА на всё приложение.
 *
 * ЗАЧЕМ ЭТОТ МОДУЛЬ. Одно и то же число TSB получало три разных словесных
 * оценки, и все три могли оказаться на экране одновременно:
 *
 *  - плитка в полосе метрик Анализа считала свои ТРИ ступени
 *    (`studio.glance.*`: свежий / устал / глубокая усталость);
 *  - подпись под кривой формы брала ЧЕТЫРЕ ступени с бэкенда
 *    (`pmc.status_*`: свежий / нейтральный / усталый / очень усталый);
 *  - линза свежести — ПЯТЬ (`lens.freshness.state_*`, добавлены в v210,
 *    там же появился коридор к старту).
 *
 * На проде 2026-08-04 при TSB −17 плитка говорила «глубокая усталость», а
 * подпись под графиком в тридцати сантиметрах ниже — «Очень усталый». Пороги у
 * первых двух совпадали, расходилось только число ступеней и слова: это не две
 * системы отсчёта, а один дубль, разошедшийся в копиях.
 *
 * v210 уже свёл линзу с плиткой по ПОРОГАМ (`lensReadout` берёт их из
 * `scienceThresholds`). Здесь тот же шаг доводится до конца: классификация
 * живёт в одном месте, а словари только переводят её результат.
 *
 * Функция чистая и без React — проверяется на входах.
 */
import { TSB_CAUTION, TSB_DEEP_FATIGUE } from "./scienceThresholds";

/**
 * Коридор свежести к старту. Верхняя граница — не вкусовщина: выше него форма
 * уже теряется, и это ровно то, что говорит методология на странице линзы
 * («TSB +5…+15 — оптимум; выше = детренированность»).
 */
export const TSB_RACE_LOW = 5;
export const TSB_RACE_HIGH = 15;

export type FreshnessState = "deep" | "tired" | "neutral" | "race" | "detrained";

/** Пять ступеней свежести по TSB. Границы — из scienceThresholds. */
export function freshnessState(tsb: number): FreshnessState {
  if (tsb < TSB_DEEP_FATIGUE) return "deep";
  if (tsb < TSB_CAUTION) return "tired";
  if (tsb < TSB_RACE_LOW) return "neutral";
  if (tsb <= TSB_RACE_HIGH) return "race";
  return "detrained";
}

/**
 * Тон плитки для той же ступени.
 *
 * «Выше коридора» — не «хорошо»: свежесть выше +15 означает, что форма уже
 * сходит, и зелёный там хвалил бы за детренированность. Поэтому у крайних
 * ступеней тон предупреждающий с обеих сторон.
 */
export function freshnessTone(state: FreshnessState): "good" | "warn" | "bad" | "muted" {
  switch (state) {
    case "deep":
      return "bad";
    case "tired":
      return "warn";
    case "neutral":
      return "muted";
    case "race":
      return "good";
    case "detrained":
      return "warn";
  }
}

/** Короткая подпись под числом. Ключи ns `analytics`. */
export function freshnessShortKey(state: FreshnessState): string {
  return `tsb_state.${state}`;
}
